import { useState } from "react";
import Button from "../../../components/Button";
import { PopupModal } from "../../../components/Modal";
import { Tooltip } from "../../../components/tooltip";
import { useSyncEnrichment, usePushAri } from "../hooks";

export function OperationsPanel({ configId }: { configId: string }) {
  const syncEnrichment = useSyncEnrichment();
  const pushAri = usePushAri();
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-[#E9E9EB] p-5">
      <div className="flex items-center gap-2 mb-4">
        <h3 className="text-base font-semibold text-gray-900">
          Hotel Operations
        </h3>
        <Tooltip id="hotel-ops-info" className="!w-[220px]">
          <p className="text-xs">
            Actions that run for this hotel only.
          </p>
        </Tooltip>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="border border-[#E9E9EB] rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <h4 className="text-sm font-medium text-gray-900">
              Sync Enrichment
            </h4>
            <Tooltip id="sync-enrichment-info" className="!w-[240px]">
              <p className="text-xs">
                Sync pricing, availability, and tax data from your PMS to
                Google.
              </p>
            </Tooltip>
          </div>
          <Button
            variant="outline"
            onClick={() => syncEnrichment.mutate(configId)}
            loading={syncEnrichment.isPending}
            disabled={syncEnrichment.isPending}
            className="w-full"
          >
            {syncEnrichment.isPending ? "Syncing..." : "Run Sync"}
          </Button>
        </div>
        <div className="border border-[#E9E9EB] rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <h4 className="text-sm font-medium text-gray-900">Push ARI</h4>
            <Tooltip id="push-ari-info" className="!w-[240px]">
              <p className="text-xs">
                Send 330 days of rate data to Google. This can take a while.
              </p>
            </Tooltip>
          </div>
          <Button
            variant="outline"
            onClick={() => setShowConfirm(true)}
            loading={pushAri.isPending}
            disabled={pushAri.isPending}
            className="w-full"
          >
            {pushAri.isPending ? "Pushing..." : "Push Rates"}
          </Button>
        </div>
      </div>

      {showConfirm && (
        <PopupModal
          onClose={() => setShowConfirm(false)}
          contentClassName="mx-auto max-w-[400px] w-full"
        >
          <div>
            <h3 className="text-lg font-semibold mb-2">Confirm Push ARI</h3>
            <p className="text-sm text-gray-600 mb-4">
              This will push 330 days of rate data to Google. This operation may
              take significant time. Are you sure?
            </p>
            <div className="flex items-center justify-end gap-3">
              <Button
                variant="outline"
                onClick={() => setShowConfirm(false)}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setShowConfirm(false);
                  pushAri.mutate(configId);
                }}
              >
                Confirm
              </Button>
            </div>
          </div>
        </PopupModal>
      )}
    </div>
  );
}
